export const AUTH_METHOD_MOBILE_APP = 'MOBILE_APP';
export const AUTH_METHOD_SMS_PLUS_QUESTION = 'SMS_QUESTION';